import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";

import {
  FiPlus,
  FiTrash2,
  FiSearch,
  FiUser,
  FiChevronsUp,
  FiChevronsDown,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiEdit,
  FiEye,
  FiPrinter,
  FiClock,
  FiCheckCircle,
  FiAlertCircle,
} from "react-icons/fi";

import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  :root {
    --teal-900: #062020;
    --teal-800: #0a3535;
    --teal-700: #0a5556;
    --teal-600: #0c7172;
    --teal-400: #14b8a6;
    --teal-200: #c8e4e4;
    --teal-100: #eef6f6;
    --teal-50:  #f3fafa;
    --gold:     #FFD166;
    --danger:   #ef4444;
    --warning:  #f59e0b;
    --success:  #10b981;
    --text-primary: #062020;
    --text-secondary: #3d6060;
    --text-muted: #6b8a8a;
    --border: rgba(10,85,86,0.13);
    --shadow-sm: 0 2px 10px rgba(10,85,86,0.07);
    --shadow-md: 0 8px 32px rgba(10,85,86,0.10);
    --radius-sm: 10px;
    --radius-md: 16px;
    --radius-lg: 24px;
  }

  @keyframes ai__fadeUp  { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
  @keyframes ai__fadeIn  { from { opacity:0; } to { opacity:1; } }
  @keyframes ai__pulse   { 0%,100% { box-shadow:0 0 0 0 rgba(10,85,86,0.35); } 70% { box-shadow:0 0 0 7px rgba(10,85,86,0); } }
  @keyframes ai__shimmer { 0% { background-position:-600px 0; } 100% { background-position:600px 0; } }
  @keyframes ai__floatA  { 0%,100% { transform:translateY(0) scale(1); } 50% { transform:translateY(-14px) scale(1.03); } }
  @keyframes ai__floatB  { 0%,100% { transform:translateY(0) scale(1); } 50% { transform:translateY(10px) scale(0.97); } }

  .ai__page {
    font-family: 'DM Sans', sans-serif;
    background: var(--teal-100);
    min-height: 100vh;
    position: relative;
    overflow-x: hidden;
  }

  .ai__blob { position: fixed; border-radius: 50%; pointer-events: none; z-index: 0; }
  .ai__blob--1 { width:420px; height:420px; top:-140px; right:-100px; background:radial-gradient(circle,rgba(10,85,86,.13) 0%,transparent 70%); animation:ai__floatA 10s ease-in-out infinite; }
  .ai__blob--2 { width:350px; height:350px; bottom:60px; left:-80px; background:radial-gradient(circle,rgba(20,184,166,.12) 0%,transparent 70%); animation:ai__floatB 12s ease-in-out infinite; }
  .ai__blob--3 { width:220px; height:220px; top:42%; right:18%; background:radial-gradient(circle,rgba(255,209,102,.13) 0%,transparent 70%); animation:ai__floatA 9s ease-in-out infinite; }
  .ai__grid { position:fixed; inset:0; pointer-events:none; z-index:0; background-image:linear-gradient(rgba(10,85,86,.035) 1px,transparent 1px),linear-gradient(90deg,rgba(10,85,86,.035) 1px,transparent 1px); background-size:52px 52px; }

  .ai__wrapper { position:relative; z-index:1; padding:22px 22px 40px; animation:ai__fadeIn .5s ease both; }

  /* header */
  .ai__header { display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; animation:ai__fadeUp .5s ease both; }
  .ai__header-left { display:flex; align-items:center; gap:13px; }
  .ai__title-icon { width:44px; height:44px; border-radius:13px; flex-shrink:0; background:linear-gradient(135deg,var(--teal-700),var(--teal-400)); display:flex; align-items:center; justify-content:center; box-shadow:0 6px 20px rgba(10,85,86,.30); color:#fff; font-size:19px; }
  .ai__title { font-family:'Sora',sans-serif; font-size:21px; font-weight:800; color:var(--teal-900); letter-spacing:-.04em; margin:0 0 2px; line-height:1; }
  .ai__subtitle { font-size:12px; color:var(--text-muted); margin:0; }

  .ai__create-btn { display:inline-flex; align-items:center; gap:7px; background:linear-gradient(135deg,var(--teal-700) 0%,var(--teal-600) 50%,var(--teal-400) 100%); background-size:200% auto; color:#fff; border:none; border-radius:var(--radius-sm); padding:10px 18px; font-family:'Sora',sans-serif; font-size:12.5px; font-weight:700; cursor:pointer; box-shadow:0 6px 22px rgba(10,85,86,.35); text-decoration:none; transition:background-position .4s,transform .15s,box-shadow .2s; position:relative; overflow:hidden; white-space:nowrap; }
  .ai__create-btn::after { content:''; position:absolute; inset:0; background:linear-gradient(90deg,transparent,rgba(255,255,255,.13),transparent); background-size:400px 100%; opacity:0; transition:opacity .3s; }
  .ai__create-btn:hover { background-position:right center; transform:translateY(-2px); box-shadow:0 12px 30px rgba(10,85,86,.42); color:#fff; text-decoration:none; }
  .ai__create-btn:hover::after { opacity:1; animation:ai__shimmer 1.1s linear infinite; }
  .ai__create-btn:active { transform:translateY(0); }

  /* ── COMPACT STATS CHIPS ── */
  .ai__stats-bar { display:flex; gap:10px; margin-bottom:18px; animation:ai__fadeUp .5s .07s ease both; }
  .ai__stat-chip { flex:1; display:flex; align-items:center; gap:10px; background:rgba(255,255,255,.90); backdrop-filter:blur(18px); border:1px solid rgba(255,255,255,.85); border-radius:12px; padding:11px 14px; box-shadow:var(--shadow-sm); position:relative; overflow:hidden; transition:transform .2s,box-shadow .2s; cursor:default; }
  .ai__stat-chip:hover { transform:translateY(-2px); box-shadow:var(--shadow-md); }
  .ai__stat-chip::after { content:''; position:absolute; top:0; left:0; bottom:0; width:3px; border-radius:12px 0 0 12px; }
  .ai__stat-chip--total::after  { background:linear-gradient(180deg,var(--teal-700),var(--teal-400)); }
  .ai__stat-chip--paid::after   { background:linear-gradient(180deg,var(--success),#34d399); }
  .ai__stat-chip--pending::after{ background:linear-gradient(180deg,var(--warning),#fbbf24); }
  .ai__stat-chip--due::after    { background:linear-gradient(180deg,var(--danger),#f87171); }

  .ai__chip-icon { width:34px; height:34px; border-radius:9px; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:15px; }
  .ai__stat-chip--total .ai__chip-icon  { background:rgba(10,85,86,.10); color:var(--teal-700); }
  .ai__stat-chip--paid .ai__chip-icon   { background:rgba(16,185,129,.12); color:var(--success); }
  .ai__stat-chip--pending .ai__chip-icon{ background:rgba(245,158,11,.12); color:var(--warning); }
  .ai__stat-chip--due .ai__chip-icon    { background:rgba(239,68,68,.12); color:var(--danger); }

  .ai__chip-body { display:flex; flex-direction:column; gap:1px; min-width:0; }
  .ai__chip-val { font-family:'Sora',sans-serif; font-size:19px; font-weight:800; color:var(--teal-900); letter-spacing:-.03em; line-height:1; }
  .ai__chip-label { font-size:10.5px; color:var(--text-muted); font-weight:500; white-space:nowrap; }

  /* main card */
  .ai__card { background:rgba(255,255,255,.90); backdrop-filter:blur(24px); border:1px solid rgba(255,255,255,.88); border-radius:var(--radius-lg); box-shadow:0 0 0 1px rgba(10,85,86,.05),var(--shadow-md),0 32px 80px rgba(0,0,0,.08); overflow:hidden; animation:ai__fadeUp .5s .13s ease both; position:relative; }
  .ai__card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:linear-gradient(90deg,var(--teal-700) 0%,var(--teal-400) 55%,var(--gold) 100%); }

  /* toolbar */
  .ai__toolbar { display:flex; align-items:center; justify-content:space-between; padding:13px 18px; border-bottom:1px solid var(--teal-200); flex-wrap:wrap; gap:9px; }
  .ai__toolbar-left { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
  .ai__toolbar-right { display:flex; align-items:center; }

  .ai__show-label { font-size:11.5px; color:var(--text-muted); font-weight:500; }
  .ai__select { background:var(--teal-50); border:1.5px solid var(--teal-200); border-radius:8px; padding:5px 9px; font-size:12px; color:var(--text-primary); font-family:'DM Sans',sans-serif; outline:none; cursor:pointer; transition:border-color .2s; }
  .ai__select:focus { border-color:var(--teal-700); }

  .ai__status-filter { display:flex; gap:5px; flex-wrap:wrap; }
  .ai__status-pill { padding:4px 11px; border-radius:50px; font-size:11px; font-weight:600; border:1.5px solid var(--teal-200); background:var(--teal-50); color:var(--text-muted); cursor:pointer; transition:all .18s; font-family:'DM Sans',sans-serif; }
  .ai__status-pill:hover { border-color:var(--teal-700); color:var(--teal-700); }
  .ai__status-pill--active { background:var(--teal-700); color:#fff; border-color:var(--teal-700); box-shadow:0 3px 10px rgba(10,85,86,.28); }

  .ai__search-wrap { position:relative; }
  .ai__search-input { padding:8px 13px 8px 34px; background:var(--teal-50); border:1.5px solid var(--teal-200); border-radius:9px; font-size:12px; color:var(--text-primary); width:230px; font-family:'DM Sans',sans-serif; outline:none; transition:border-color .2s,box-shadow .2s,width .3s; }
  .ai__search-input:focus { border-color:var(--teal-700); width:270px; box-shadow:0 0 0 3px rgba(10,85,86,.10); background:#fff; }
  .ai__search-input::placeholder { color:#9ababa; }
  .ai__search-icon { position:absolute; left:10px; top:50%; transform:translateY(-50%); color:#9ababa; font-size:13px; pointer-events:none; }

  /* table */
  .ai__table-wrap { overflow-x:auto; }
  .ai__table { width:100%; border-collapse:collapse; font-family:'DM Sans',sans-serif; }
  .ai__table thead tr { background:linear-gradient(135deg,rgba(10,85,86,.05) 0%,rgba(20,184,166,.025) 100%); border-bottom:1.5px solid var(--teal-200); }
  .ai__table thead th { padding:10px 16px; font-family:'Sora',sans-serif; font-size:10px; font-weight:700; color:var(--teal-700); letter-spacing:.07em; text-transform:uppercase; white-space:nowrap; user-select:none; }
  .ai__table thead th.sortable { cursor:pointer; }
  .ai__table thead th.sortable:hover { color:var(--teal-900); }
  .ai__table tbody tr { border-bottom:1px solid rgba(10,85,86,.06); transition:background .15s; }
  .ai__table tbody tr:last-child { border-bottom:none; }
  .ai__table tbody tr:hover { background:rgba(10,85,86,.033); }
  .ai__table td { padding:11px 16px; font-size:12.5px; color:var(--text-primary); vertical-align:middle; }

  .ai__inv-num { font-family:'Sora',sans-serif; font-weight:700; color:var(--teal-700); font-size:12px; background:rgba(10,85,86,.08); padding:3px 8px; border-radius:6px; display:inline-block; }

  .ai__customer { display:flex; align-items:center; gap:9px; }
  .ai__avatar { width:32px; height:32px; border-radius:9px; flex-shrink:0; background:linear-gradient(135deg,rgba(10,85,86,.12),rgba(20,184,166,.10)); border:1.5px solid var(--teal-200); display:flex; align-items:center; justify-content:center; color:var(--teal-700); font-size:14px; }
  .ai__cust-name { font-weight:600; font-size:12.5px; color:var(--teal-900); }
  .ai__cust-ref  { font-size:10.5px; color:var(--text-muted); margin-top:1px; }

  .ai__date { font-size:12px; color:var(--text-secondary); }
  .ai__date--due { color:var(--danger); font-weight:700; }

  .ai__amount { font-family:'Sora',sans-serif; font-weight:700; font-size:13px; color:var(--teal-700); text-align:right; }

  .ai__badge-status { display:inline-flex; align-items:center; gap:5px; padding:3px 9px; border-radius:50px; font-size:10.5px; font-weight:700; font-family:'Sora',sans-serif; letter-spacing:.04em; white-space:nowrap; }
  .ai__badge-status::before { content:''; width:5px; height:5px; border-radius:50%; }
  .ai__badge--paid    { background:rgba(16,185,129,.12); color:#059669; }
  .ai__badge--paid::before { background:#059669; }
  .ai__badge--pending { background:rgba(245,158,11,.13); color:#b45309; }
  .ai__badge--pending::before { background:#b45309; }
  .ai__badge--due     { background:rgba(239,68,68,.12); color:#dc2626; }
  .ai__badge--due::before { background:#dc2626; }
  .ai__badge--draft   { background:rgba(10,85,86,.09); color:var(--teal-700); }
  .ai__badge--draft::before { background:var(--teal-700); }

  .ai__actions { display:flex; align-items:center; justify-content:center; gap:3px; }
  .ai__action-btn { width:29px; height:29px; border-radius:7px; display:flex; align-items:center; justify-content:center; border:1.5px solid transparent; background:transparent; color:var(--text-muted); font-size:13px; cursor:pointer; transition:all .18s; }
  .ai__action-btn:hover { transform:translateY(-1px); }
  .ai__action-btn--view:hover   { background:rgba(10,85,86,.10); border-color:var(--teal-200); color:var(--teal-700); }
  .ai__action-btn--edit:hover   { background:rgba(20,184,166,.12); border-color:rgba(20,184,166,.30); color:var(--teal-600); }
  .ai__action-btn--print:hover  { background:rgba(255,209,102,.18); border-color:rgba(255,209,102,.50); color:#b45309; }
  .ai__action-btn--delete:hover { background:rgba(239,68,68,.10); border-color:rgba(239,68,68,.25); color:var(--danger); }

  .ai__empty { text-align:center; padding:56px 32px; animation:ai__fadeUp .4s ease both; }
  .ai__empty-icon { width:60px; height:60px; border-radius:18px; margin:0 auto 14px; background:linear-gradient(135deg,rgba(10,85,86,.10),rgba(20,184,166,.07)); border:1.5px solid var(--teal-200); display:flex; align-items:center; justify-content:center; font-size:24px; color:var(--teal-700); }
  .ai__empty-title { font-family:'Sora',sans-serif; font-weight:700; font-size:15px; color:var(--teal-900); margin-bottom:4px; }
  .ai__empty-sub   { font-size:12.5px; color:var(--text-muted); }

  .ai__footer { display:flex; align-items:center; justify-content:space-between; padding:11px 18px; border-top:1px solid var(--teal-200); flex-wrap:wrap; gap:9px; background:rgba(10,85,86,.02); }
  .ai__footer-info { font-size:11.5px; color:var(--text-muted); }
  .ai__footer-info strong { color:var(--teal-700); }

  .ai__pag { display:flex; align-items:center; gap:3px; }
  .ai__pag-btn { min-width:30px; height:30px; border-radius:7px; border:1.5px solid var(--teal-200); background:var(--teal-50); color:var(--text-secondary); font-size:12px; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:3px; padding:0 8px; transition:all .18s; }
  .ai__pag-btn:hover:not(:disabled) { background:rgba(10,85,86,.09); border-color:var(--teal-700); color:var(--teal-700); }
  .ai__pag-btn--active { background:linear-gradient(135deg,var(--teal-700),var(--teal-400)); border-color:var(--teal-700); color:#fff; box-shadow:0 4px 12px rgba(10,85,86,.28); }
  .ai__pag-btn:disabled { opacity:.35; cursor:not-allowed; }

  @media (max-width: 900px) {
    .ai__stats-bar { flex-wrap:wrap; }
    .ai__stat-chip { flex:1 1 calc(50% - 5px); }
    .ai__wrapper { padding:14px 12px 28px; }
    .ai__toolbar { flex-direction:column; align-items:flex-start; }
    .ai__search-input { width:100% !important; }
    .ai__header { flex-direction:column; align-items:flex-start; gap:10px; }
  }
  @media (max-width: 480px) {
    .ai__stat-chip { flex:1 1 100%; }
  }
`;

const formatCurrency = (amount) =>
  Number(amount).toLocaleString("en-IN", {
    style: "currency", currency: "INR",
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  if (totalItems === 0) return null;
  let start = Math.max(1, currentPage - 2), end = Math.min(totalPages, currentPage + 2);
  if (currentPage <= 3) { start = 1; end = Math.min(5, totalPages); }
  else if (currentPage + 2 >= totalPages) { end = totalPages; start = Math.max(1, totalPages - 4); }
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);
  return (
    <div className="ai__pag">
      <button className="ai__pag-btn" onClick={() => onPageChange(1)} disabled={currentPage === 1}>First</button>
      <button className="ai__pag-btn" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}><FiChevronLeft size={12} /> Prev</button>
      {pages.map((p) => (<button key={p} className={`ai__pag-btn ${currentPage === p ? "ai__pag-btn--active" : ""}`} onClick={() => onPageChange(p)}>{p}</button>))}
      <button className="ai__pag-btn" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next <FiChevronRight size={12} /></button>
      <button className="ai__pag-btn" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>Last</button>
    </div>
  );
};

function AllInvoice() {
  const [invoices, setInvoices]         = useState([]);
  const [loading, setLoading]           = useState(true);
  const [searchTerm, setSearchTerm]     = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [dateRange, setDateRange]       = useState({ start: "", end: "" });
  const [sortBy, setSortBy]             = useState({ key: "invoiceDate", direction: "desc" });
  const [currentPage, setCurrentPage]   = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const token = localStorage.getItem("auth_token");

  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${baseurl}getAllInvoicesByBusiness`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success) {
          setInvoices(res.data.data.map((inv) => ({
            id: inv.id,
            invoice_number: inv.invoice_number,
            customerName: inv.invoice_data.customer?.name || "-",
            invoiceDate: inv.invoice_data.invoiceDate,
            dueDate: inv.invoice_data.dueDate,
            grandTotal: Number(inv.grand_total),
            status: inv.invoice_data.paymentStatus || "Draft",
          })));
        }
      } catch (error) {
        console.error("❌ Fetch invoices error:", error);
        Swal.fire("Error", "Failed to load invoices", "error");
      } finally { setLoading(false); }
    };
    fetchInvoices();
  }, [token]);

  const stats = useMemo(() => ({
    total:   invoices.length,
    paid:    invoices.filter((i) => i.status === "Paid").length,
    pending: invoices.filter((i) => i.status === "Pending").length,
    due:     invoices.filter((i) => i.status === "Overdue").length,
  }), [invoices]);

  const processedInvoices = useMemo(() => {
    let list = [...invoices];
    if (searchTerm.trim()) {
      const s = searchTerm.trim().toLowerCase();
      list = list.filter((i) =>
        i.invoice_number.toLowerCase().includes(s) ||
        i.customerName.toLowerCase().includes(s) ||
        String(i.grandTotal).toLowerCase().includes(s)
      );
    }
    if (statusFilter !== "All") list = list.filter((i) => i.status === statusFilter);
    if (dateRange.start) list = list.filter((i) => i.invoiceDate >= dateRange.start);
    if (dateRange.end)   list = list.filter((i) => i.invoiceDate <= dateRange.end);
    list.sort((a, b) => {
      const aVal = a[sortBy.key], bVal = b[sortBy.key];
      const cmp = sortBy.key === "grandTotal" ? Number(aVal) - Number(bVal) : String(aVal).localeCompare(String(bVal));
      return sortBy.direction === "asc" ? cmp : -cmp;
    });
    return list;
  }, [invoices, searchTerm, statusFilter, dateRange, sortBy]);

  useEffect(() => setCurrentPage(1), [searchTerm, statusFilter, dateRange, sortBy, itemsPerPage]);

  const totalItems = processedInvoices.length;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex   = Math.min(startIndex + itemsPerPage, totalItems);
  const paginated  = processedInvoices.slice(startIndex, endIndex);

  const handleSort = (key) =>
    setSortBy((prev) => prev.key === key
      ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
      : { key, direction: "desc" });

  const SortIcon = ({ columnKey }) => {
    if (sortBy.key !== columnKey) return null;
    return sortBy.direction === "asc"
      ? <FiChevronsUp size={11} style={{ marginLeft: 3, opacity: 0.7 }} />
      : <FiChevronsDown size={11} style={{ marginLeft: 3, opacity: 0.7 }} />;
  };

  const getStatusBadge = (status) => {
    const map = { Paid: "ai__badge--paid", Overdue: "ai__badge--due", Pending: "ai__badge--pending", Draft: "ai__badge--draft" };
    const label = status === "Overdue" ? "Due" : status;
    return <span className={`ai__badge-status ${map[status] || "ai__badge--draft"}`}>{label}</span>;
  };

  const handleEditInvoice   = (id) => { window.location.href = `/invoice-edit/${btoa(id.toString())}`; };
  const handlePrintInvoice  = (id) => { window.open(`/invoice/${btoa(id.toString())}`, '_blank', 'noopener,noreferrer'); };
  const handleDeleteInvoice = (id) => {
    Swal.fire({ title: 'Are you sure?', text: `You want to delete invoice ${id}?`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes, delete it!' })
      .then((r) => { if (r.isConfirmed) alert(`Deleted invoice ${id}`); });
  };

  const renderSkeletonRows = () =>
    Array.from({ length: itemsPerPage }).map((_, i) => (
      <tr key={i}>
        <td><Skeleton width={72} height={22} borderRadius={6} /></td>
        <td><div style={{ display:"flex", alignItems:"center", gap:9 }}><Skeleton circle height={32} width={32} /><div><Skeleton width={105} height={11} /><Skeleton width={65} height={9} style={{ marginTop:4 }} /></div></div></td>
        <td><Skeleton width={76} height={11} /></td>
        <td><Skeleton width={76} height={11} /></td>
        <td style={{ textAlign:"right" }}><Skeleton width={70} height={11} /></td>
        <td><Skeleton width={58} height={19} borderRadius={50} /></td>
        <td><Skeleton width={90} height={25} borderRadius={7} /></td>
      </tr>
    ));

  const STATUS_TABS = ["All", "Paid", "Pending", "Due", "Draft"];

  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="ai__page">
          <div className="ai__blob ai__blob--1" />
          <div className="ai__blob ai__blob--2" />
          <div className="ai__blob ai__blob--3" />
          <div className="ai__grid" />

          <div className="ai__wrapper">

            {/* Header */}
            <div className="ai__header">
              <div className="ai__header-left">
                <div className="ai__title-icon"><FiFileText /></div>
                <div>
                  <h2 className="ai__title">All Invoices</h2>
                  <p className="ai__subtitle">Manage invoices, track payments &amp; due amounts</p>
                </div>
              </div>
              <Link to="/invoice-create" className="ai__create-btn">
                <FiPlus size={14} /> Create Invoice
              </Link>
            </div>

            {/* Compact Stats Chips */}
            <div className="ai__stats-bar">
              <div className="ai__stat-chip ai__stat-chip--total">
                <div className="ai__chip-icon"><FiFileText size={15} /></div>
                <div className="ai__chip-body">
                  <div className="ai__chip-val">{loading ? <Skeleton width={28} height={16} /> : stats.total}</div>
                  <div className="ai__chip-label">Total Invoices</div>
                </div>
              </div>
              <div className="ai__stat-chip ai__stat-chip--paid">
                <div className="ai__chip-icon"><FiCheckCircle size={15} /></div>
                <div className="ai__chip-body">
                  <div className="ai__chip-val">{loading ? <Skeleton width={28} height={16} /> : stats.paid}</div>
                  <div className="ai__chip-label">Paid</div>
                </div>
              </div>
              <div className="ai__stat-chip ai__stat-chip--pending">
                <div className="ai__chip-icon"><FiClock size={15} /></div>
                <div className="ai__chip-body">
                  <div className="ai__chip-val">{loading ? <Skeleton width={28} height={16} /> : stats.pending}</div>
                  <div className="ai__chip-label">Pending</div>
                </div>
              </div>
              <div className="ai__stat-chip ai__stat-chip--due">
                <div className="ai__chip-icon"><FiAlertCircle size={15} /></div>
                <div className="ai__chip-body">
                  <div className="ai__chip-val">{loading ? <Skeleton width={28} height={16} /> : stats.due}</div>
                  <div className="ai__chip-label">Due</div>
                </div>
              </div>
            </div>

            {/* Main card */}
            <div className="ai__card">
              <div className="ai__toolbar">
                <div className="ai__toolbar-left">
                  <span className="ai__show-label">Show</span>
                  <select className="ai__select" value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))}>
                    <option value={5}>5</option><option value={10}>10</option>
                    <option value={20}>20</option><option value={invoices.length || 9999}>All</option>
                  </select>
                  <div className="ai__status-filter">
                    {STATUS_TABS.map((s) => (
                      <button key={s} className={`ai__status-pill ${statusFilter === s ? "ai__status-pill--active" : ""}`} onClick={() => setStatusFilter(s)}>
                        {s === "Overdue" ? "Due" : s}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="ai__toolbar-right">
                  <div className="ai__search-wrap">
                    <FiSearch className="ai__search-icon" />
                    <input type="text" className="ai__search-input" placeholder="Search ID, customer or amount..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                  </div>
                </div>
              </div>

              <div className="ai__table-wrap">
                <table className="ai__table">
                  <thead>
                    <tr>
                      <th className="sortable" onClick={() => handleSort("invoice_number")}>Invoice ID <SortIcon columnKey="invoice_number" /></th>
                      <th className="sortable" onClick={() => handleSort("customerName")}>Customer <SortIcon columnKey="customerName" /></th>
                      <th className="sortable" onClick={() => handleSort("invoiceDate")}>Invoice Date <SortIcon columnKey="invoiceDate" /></th>
                      <th className="sortable" onClick={() => handleSort("dueDate")}>Due Date <SortIcon columnKey="dueDate" /></th>
                      <th className="sortable" style={{ textAlign:"right" }} onClick={() => handleSort("grandTotal")}>Amount <SortIcon columnKey="grandTotal" /></th>
                      <th>Status</th>
                      <th style={{ textAlign:"center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? renderSkeletonRows() : (
                      paginated.length === 0 ? (
                        <tr><td colSpan="7">
                          <div className="ai__empty">
                            <div className="ai__empty-icon"><FiFileText /></div>
                            <div className="ai__empty-title">No invoices found</div>
                            <div className="ai__empty-sub">Try adjusting your search or filter criteria.</div>
                          </div>
                        </td></tr>
                      ) : paginated.map((inv) => (
                        <tr key={inv.id}>
                          <td><span className="ai__inv-num">{inv.invoice_number}</span></td>
                          <td>
                            <div className="ai__customer">
                              <div className="ai__avatar"><FiUser /></div>
                              <div>
                                <div className="ai__cust-name">{inv.customerName}</div>
                                <div className="ai__cust-ref">Ref: {inv.invoice_number}</div>
                              </div>
                            </div>
                          </td>
                          <td><span className="ai__date">{inv.invoiceDate}</span></td>
                          <td><span className={`ai__date ${inv.status === "Overdue" ? "ai__date--due" : ""}`}>{inv.dueDate}</span></td>
                          <td className="ai__amount">{formatCurrency(inv.grandTotal)}</td>
                          <td>{getStatusBadge(inv.status)}</td>
                          <td>
                            <div className="ai__actions">
                              <button className="ai__action-btn ai__action-btn--view"   title="View"   onClick={() => {}}><FiEye size={13} /></button>
                              <button className="ai__action-btn ai__action-btn--edit"   title="Edit"   onClick={() => handleEditInvoice(inv.id)}><FiEdit size={13} /></button>
                              <button className="ai__action-btn ai__action-btn--print"  title="Print"  onClick={() => handlePrintInvoice(inv.id)}><FiPrinter size={13} /></button>
                              <button className="ai__action-btn ai__action-btn--delete" title="Delete" onClick={() => handleDeleteInvoice(inv.id)}><FiTrash2 size={13} /></button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="ai__footer">
                <div className="ai__footer-info">
                  Showing <strong>{totalItems === 0 ? 0 : startIndex + 1}</strong> to <strong>{endIndex}</strong> of <strong>{totalItems}</strong> invoices
                </div>
                <Pagination totalItems={totalItems} itemsPerPage={itemsPerPage} currentPage={currentPage}
                  onPageChange={(p) => setCurrentPage(Math.max(1, Math.min(p, Math.ceil(totalItems / itemsPerPage))))} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AllInvoice;
